export interface StatusReason {
    id: number;
    order_status_id: number;
    to_status_id: number | null;
    restore_prev_status: 0 | 1;
    title: string;
    key: string;
}

interface OrderStatusWorkerPositionPivot {
    order_status_id: number;
    worker_position_id: number;
}

interface OrderStatusWorkerPositionUser {
    id: number;
    surname: string;
    name: string;
    patronymic: string;
    phone: string;
    country: string;
    address: string;
    email: string;
}

interface OrderStatusWorkerPosition {
    id: number;
    percentage_work: number;
    percentage_product: number;
    rate: number;
    rating: number;
    crm_id: number;
    role_id: number | null;
    user_id: number;
    receive_crm_id: number | null;
    banned: 0 | 1;
    name: string;
    is_archived: 0 | 1;
    balance: string;
    hex: string | null;
    type: string;
    hot: 0 | 1;
    show_in_landing: 0 | 1;
    rate_type: string;
    pivot: OrderStatusWorkerPositionPivot;
    user: OrderStatusWorkerPositionUser;
    receive_crm: unknown | null;
}

export interface TOrderStatus {
    id: number;
    title: string;
    key: number;
    color: string;
    reasons: StatusReason[];
    client: 0 | 1;
    workerPositions: Array<OrderStatusWorkerPosition>;
}
// Значения key статусов заказов
export enum ORDER_STATUS_TYPES {
    ORDER_CREATE = 3, // Необходимо согласовать (было id: 1)
    UNDER_APPROVAL = 1, // На согласовании (было id: 2)
    NOT_APPROVED = 13, // Не согласовано (было id: 3)
    APPROVED = 2, // Согласовано (было id: 4)
    START_DELAY = 4, // Задержка старта (было id: 5)
    CANCELED = 11, // Отменён (было id: 6)
    IN_PROGRESS = 5, // В работе (было id: 7)
    WAITING = 6, // Ожидание (было id: 8)
    DELAY_COMPLETION = 9, // Задержка завершения (было id: 9)
    AWAITING_PAYMENTS = 7, // Ожидает оплаты (было id: 10)
    PAID = 8, // Оплачено (было id: 11)
    COMPLETED = 10, // Завершён (было id: 12)
}
